import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-translate-email-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [isTranslator]="true"
      [templateType]="templateType"
      templateBasePath="/translate-email-template/"
      [enableDragDrop]="true"
      [enableBlockToolbar]="true"
      [showResponsysButton]="true"
      [showSaveAsEmpty]="true" />
  `
})
export class TranslateEmailTemplateComponent {
  protected readonly templateType = TypeEnum.EMAIL;
}
